import styled from "@emotion/styled";

export const ProductGridContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.space?.space16};
  grid-column: span 3;

  @media (min-width: ${({ theme }) => theme.breakpoints?.md}) {
    display: grid;
    grid-template-columns: 1fr;
  }
`;

export const ListingContainer = styled.div`
  display: grid;

  @media (min-width: ${({ theme }) => theme.breakpoints?.md}) {
    grid-gap: ${({ theme }) => theme.space?.space32};
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    grid-gap: ${({ theme }) => theme.space?.space32};
    grid-template-columns: 1fr;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints?.xl}) {
    grid-gap: ${({ theme }) => theme.space?.space24};
  }
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-column: span 3;
  gap: ${({ theme }) => theme.space.space24};
`;

export const PromoWrapper = styled.div`
  position: relative;
  grid-column: span 3;
  display: grid;
  grid-template-rows: ${({ theme }) =>
    `minmax(${
      (theme.space?.space96 || "") +
      (theme.space?.space64 || "") +
      (theme.space?.space24 || "")
    }, 1fr)`};
  transition: all 250ms ease-in-out;
`;

export const CategoryTreeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.space?.space24};

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    display: none;
  }
`;

export const NoResultsWrapper = styled.div`
  grid-column: span 3;
`;

export const PromotionBlockSkeletonWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors?.tone.white};
  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.space?.space24};
`;

export const StyledAuthBanner = styled.div<{ hideCategoryTree?: boolean }>`
  grid-column: span 2;

  @media (min-width: ${({ theme }) => theme.breakpoints?.sm}) {
    grid-column: ${({ hideCategoryTree }) =>
      hideCategoryTree ? "span 4" : "span 3"};
  }
`;
